const A: Record<string, [string, string]> = {
  admin_member_added: ["إضافة عضو لفريق الإدارة", "Admin team member added"],
  admin_member_removed: ["حذف عضو من فريق الإدارة", "Admin team member removed"],
  admin_role_changed: ["تغيير دور عضو بالإدارة", "Admin role changed"],
  team_member_added: ["إضافة موظف لفريق الشريك", "Partner staff added"],
  team_member_removed: ["حذف موظف من فريق الشريك", "Partner staff removed"],
  team_role_changed: ["تغيير دور موظف الشريك", "Partner staff role changed"],
  attendance_recorded: ["تسجيل حضور", "Attendance recorded"],
  balance_reminder_set: ["ضبط تذكير الرصيد", "Balance reminder set"],
  booking_confirmed: ["قبول حجز", "Booking confirmed"],
  booking_rejected: ["رفض حجز", "Booking rejected"],
  booking_unable_to_contact: ["تعذر التواصل مع صاحب الحجز", "Couldn't reach customer"],
  booking_attended: ["تسجيل حضور حجز", "Booking attended"],
  booking_no_show: ["عدم حضور صاحب الحجز", "Booking no-show"],
  booking_cancelled_by_admin: ["إلغاء حجز من الإدارة", "Booking cancelled by admin"],
  booking_cancelled_by_venue: ["إلغاء حجز من الشريك", "Booking cancelled by partner"],
  booking_change_approved: ["قبول تعديل عدد الأشخاص", "Guests change approved"],
  booking_change_rejected: ["رفض تعديل عدد الأشخاص", "Guests change rejected"],
  booking_details_changed: ["تعديل بيانات حجز", "Booking details changed"],
  booking_details_changed_by_admin: ["تعديل بيانات حجز من الإدارة", "Booking details changed by admin"],
  external_booking_added: ["إضافة حجز خارجي", "External booking added"],
  customer_deleted: ["حذف حساب زبون", "Customer deleted"],
  partner_deleted: ["حذف حساب شريك", "Partner deleted"],
  account_disabled: ["تعطيل حساب", "Account disabled"],
  account_enabled: ["تفعيل حساب", "Account enabled"],
  event_created: ["إنشاء فعالية", "Event created"],
  event_updated: ["تعديل فعالية", "Event updated"],
  event_copied: ["نسخ فعالية", "Event copied"],
  event_cancelled: ["إلغاء فعالية", "Event cancelled"],
  event_hide: ["إخفاء فعالية", "Event hidden"],
  event_unhide: ["إظهار فعالية", "Event shown"],
  event_requests_opened: ["فتح طلبات الحجز", "Booking requests opened"],
  event_review_deleted: ["حذف تقييم فعالية", "Event rating deleted"],
  event_type_created: ["إضافة تصنيف فعاليات", "Event category added"],
  event_type_updated: ["تعديل تصنيف فعاليات", "Event category updated"],
  event_type_deleted: ["حذف تصنيف فعاليات", "Event category deleted"],
  venue_category_created: ["إضافة تصنيف أماكن", "Place category added"],
  venue_category_updated: ["تعديل تصنيف أماكن", "Place category updated"],
  venue_category_deleted: ["حذف تصنيف أماكن", "Place category deleted"],
  spot_category_created: ["إضافة تصنيف أماكن عامة", "Spot category added"],
  spot_category_updated: ["تعديل تصنيف أماكن عامة", "Spot category updated"],
  spot_category_deleted: ["حذف تصنيف أماكن عامة", "Spot category deleted"],
  public_spot_created: ["إضافة مكان عام", "Public spot added"],
  public_spot_updated: ["تعديل مكان عام", "Public spot updated"],
  public_spot_deleted: ["حذف مكان عام", "Public spot deleted"],
  spot_review_approved: ["قبول تقييم مكان عام", "Spot review approved"],
  spot_review_rejected: ["رفض تقييم مكان عام", "Spot review rejected"],
  spot_review_deleted: ["حذف تقييم مكان عام", "Spot review deleted"],
  spot_suggestion_approved: ["قبول اقتراح مكان عام", "Spot suggestion approved"],
  spot_suggestion_rejected: ["رفض اقتراح مكان عام", "Spot suggestion rejected"],
  venue_created: ["إضافة مكان", "Place added"],
  venue_updated: ["تعديل مكان", "Place updated"],
  venue_approved: ["قبول مكان", "Place approved"],
  venue_rejected: ["رفض مكان", "Place rejected"],
  venue_pending: ["إرجاع مكان للمراجعة", "Place sent back to review"],
  place_deleted: ["حذف مكان", "Place deleted"],
  venue_account_approve: ["قبول حساب شريك", "Partner account approved"],
  venue_account_reject: ["رفض حساب شريك", "Partner account rejected"],
  venue_account_suspend: ["إيقاف حساب شريك", "Partner account suspended"],
  venue_account_reactivate: ["إعادة تفعيل حساب شريك", "Partner account reactivated"],
  fee_rule_set: ["تغيير نظام رسوم شريك", "Partner fee plan changed"],
  ledger_payment: ["تسجيل دفعة من شريك", "Partner payment recorded"],
  ledger_debit_adj: ["تسوية مدينة على شريك", "Debit adjustment"],
  ledger_credit_adj: ["تسوية دائنة لشريك", "Credit adjustment"],
  ledger_reversed: ["إلغاء قيد مالي", "Ledger entry reversed"],
  ledger_entries_removed: ["حذف قيود مالية خاطئة", "Wrong ledger entries removed"],
  receipt_resent: ["إعادة إرسال وصل", "Receipt resent"],
  launch_exemption_set: ["ضبط إعفاء فترة الإطلاق", "Launch exemption set"],
  image_limits_set: ["ضبط حجم الصور", "Image limits set"],
  images_recompress_started: ["بدء ضغط الصور الموجودة", "Image compression started"],
  platform_contact_set: ["تعديل رقم تواصل المنصة", "Platform contact set"],
  reject_reasons_set: ["تعديل أسباب الرفض", "Reject reasons updated"],
  wa_templates_updated: ["تعديل قوالب واتساب", "WhatsApp templates updated"],
  password_changed: ["تغيير كلمة المرور", "Password changed"],
  customer_sections_set: ["تغيير أقسام الزبائن الظاهرة", "Customer sections changed"],
  platform_about_set: ["تعديل صفحة عن التطبيق", "About page updated"],
  platform_legal_set: ["تعديل الشروط أو سياسة الخصوصية", "Terms or privacy updated"],
  venue_edit_submitted: ["إرسال تعديل مكان للموافقة", "Place edit submitted"],
  venue_edit_approved: ["موافقة على تعديل مكان", "Place edit approved"],
  venue_edit_rejected: ["رفض تعديل مكان", "Place edit rejected"],
  venue_events_on: ["تفعيل الفعاليات لمكان", "Events turned on for place"],
  venue_events_off: ["إطفاء الفعاليات لمكان", "Events turned off for place"],
  customer_reset_requested: ["طلب إعادة تعيين كلمة المرور", "Password reset requested"],
  customer_password_reset: ["إعادة تعيين كلمة المرور", "Password reset"],
  customer_reset_renewed: ["رمز إعادة تعيين جديد", "Reset code renewed"],
  devices_signed_out_all: ["تسجيل خروج كل الأجهزة", "All devices signed out"],
  password_reset: ["إعادة تعيين كلمة المرور", "Password reset"],
  password_reset_by_admin: ["إعادة تعيين كلمة المرور من الإدارة", "Password reset by admin"],
  phone_verified: ["تأكيد رقم الهاتف", "Phone verified"],
  login_alert_not_me: ["الإبلاغ عن دخول غير معروف", "Unknown sign-in reported"],
  device_signed_out: ["تسجيل خروج جهاز", "Device signed out"],
  review_reply_deleted: ["حذف رد شريك على تقييم", "Partner reply deleted"],
  case_resolved: ["إغلاق حالة", "Case resolved"],
  case_dismissed: ["رفض حالة", "Case dismissed"],
  case_open: ["فتح حالة", "Case opened"],
};
const ROLES: Record<string, [string, string]> = { admin: ["الإدارة", "Admin"], venue: ["شريك", "Partner"], customer: ["زبون", "Customer"], system: ["النظام", "System"] };
const TARGETS: Record<string, [string, string]> = {
  booking: ["حجز", "Booking"], event: ["فعالية", "Event"], venue: ["مكان", "Place"], venue_account: ["حساب شريك", "Partner account"], user: ["مستخدم", "User"],
  customers: ["زبون", "Customer"], partners: ["شريك", "Partner"], platform: ["المنصة", "Platform"], public_spot: ["مكان عام", "Public spot"],
  spot_category: ["تصنيف أماكن عامة", "Spot category"], venue_category: ["تصنيف أماكن", "Place category"], event_type: ["تصنيف فعاليات", "Event category"],
  spot_review: ["تقييم مكان عام", "Spot review"], spot_suggestion: ["اقتراح مكان", "Spot suggestion"], event_review: ["تقييم فعالية", "Event rating"], case: ["حالة", "Case"],
};
const pick = (m: Record<string, [string, string]>, k: string, lang: string) => (m[k] ? m[k][lang === "ar" ? 0 : 1] : k);
export const auditAction = (k: string, lang: string) => pick(A, k, lang);
export const auditRole = (k: string, lang: string) => pick(ROLES, k, lang);
export const auditTarget = (k: string, lang: string) => pick(TARGETS, k, lang);
export const AUDIT_ACTIONS = Object.keys(A);

const CTX: Record<string, [string, string]> = {
  partner: ["الشريك", "Partner"], venue: ["المكان", "Place"], event: ["الفعالية", "Event"], customer: ["الزبون", "Customer"], code: ["رقم الحجز", "Booking code"],
  author: ["صاحب التقييم", "Rated by"], person: ["الشخص", "Person"], spot: ["المكان العام", "Public spot"], category: ["التصنيف", "Category"],
};
const DET: Record<string, [string, string]> = {
  reason: ["السبب", "Reason"], business_name: ["الشريك", "Partner"], name: ["الاسم", "Name"], name_ar: ["الاسم", "Name"], name_en: ["الاسم بالإنكليزي", "English name"],
  email: ["البريد", "Email"], device: ["الجهاز", "Device"], ip: ["عنوان الإنترنت", "IP"], from: ["من", "From"], to: ["إلى", "To"], model: ["نظام الرسوم", "Fee plan"],
  amount: ["المبلغ", "Amount"], currency: ["العملة", "Currency"], effective_from: ["يبدأ من", "Starts"], exempt: ["معفى", "Exempt"], exemption_days: ["أيام الإعفاء", "Exemption days"],
  trial_days: ["أيام التجربة", "Trial days"], admin_role: ["الدور", "Role"], venue_role: ["الدور", "Role"], by: ["بواسطة", "By"], active: ["مفعّل", "Active"],
  bookings_cancelled: ["حجوزات انلغت", "Bookings cancelled"], bookings_notified: ["حجوزات انبلغت", "Bookings notified"], count: ["العدد", "Count"], delayed: ["إدخال متأخر", "Late entry"],
  note: ["ملاحظة", "Note"], whatsapp: ["واتساب", "WhatsApp"], max_kb: ["الحد الأقصى (كيلوبايت)", "Max KB"], max_side: ["أقصى طول (بكسل)", "Max side"], entries: ["القيود", "Entries"],
  fields: ["الحقول المعدلة", "Changed fields"], material_fields: ["حقول مهمة تغيّرت", "Key fields changed"],
};
const VAL: Record<string, [string, string]> = {
  pending: ["قيد المراجعة", "Pending"], approved: ["مقبول", "Approved"], rejected: ["مرفوض", "Rejected"], suspended: ["موقوف", "Suspended"], active: ["فعّال", "Active"],
  per_booking: ["على أساس الحجز", "Per booking"], per_event: ["على أساس الفعالية", "Per event"], monthly: ["اشتراك شهري", "Monthly"], free_trial: ["تجربة مجانية", "Free trial"],
  owner: ["مالك", "Owner"], staff: ["موظف", "Staff"], reception: ["استقبال", "Reception"], finance: ["مالية", "Finance"], super: ["مدير عام", "General manager"],
  admin: ["الإدارة", "Admin"], venue: ["الشريك", "Partner"], customer: ["الزبون", "Customer"], true: ["نعم", "Yes"], false: ["لا", "No"],
};
const HIDE = new Set(["fee_id", "op_id", "entry_id", "user_id", "booking_id", "event_id", "venue_id", "account_id"]);
const lab = (m: Record<string, [string, string]>, k: string, lang: string) => (m[k] ? m[k][lang === "ar" ? 0 : 1] : null);
const val = (v: unknown, lang: string): string => {
  if (v === null || v === undefined || v === "") return "";
  if (Array.isArray(v)) return v.map((x) => val(x, lang)).filter(Boolean).join("، ");
  if (typeof v === "object") return "";
  const s = String(v);
  return lab(VAL, s, lang) || s;
};

export type AuditFact = { label: string; value: string };
export const auditFacts = (ctx: Record<string, unknown> = {}, details: Record<string, unknown> = {}, lang: string): AuditFact[] => {
  const out: AuditFact[] = [];
  const seen = new Set<string>();
  const push = (label: string | null, v: unknown) => {
    const value = val(v, lang);
    if (!label || !value || seen.has(label + value)) return;
    seen.add(label + value);
    out.push({ label, value });
  };
  Object.entries(ctx).forEach(([k, v]) => push(lab(CTX, k, lang), v));
  Object.entries(details).forEach(([k, v]) => { if (!HIDE.has(k)) push(lab(DET, k, lang), v); });
  return out;
};
